// Quali file si possono aprire dentro il prodotto, e di che genere sono.
//
// Stava dentro VaultPage.jsx (2026-09-08 spostata qui): serve anche alla
// pagina pubblica di condivisione, che deve decidere se un file si apre o
// si scarica soltanto. Due copie della stessa tabella si sarebbero separate
// al primo formato aggiunto da una parte sola — e la pagina di condivisione
// non e' raggiungibile dal vault, quindi nessuno se ne sarebbe accorto.
//
// L'estensione, non il mimeType: il mimeType lo dichiara chi carica, e su
// WebDAV spesso e' application/octet-stream per tutto.
export const PREVIEW_TYPES = {
  jpg:'image', jpeg:'image', png:'image', gif:'image', webp:'image', svg:'image', bmp:'image',
  mp4:'video', webm:'video', mov:'video', mp3:'audio', m4a:'audio', wav:'audio', flac:'audio',
  pdf:'pdf', txt:'text', md:'text', json:'text', js:'text', ts:'text',
  jsx:'text', tsx:'text', css:'text', html:'text', py:'text', csv:'text',
  sh:'text', bash:'text', zsh:'text', yml:'text', yaml:'text', xml:'text',
  ini:'text', cfg:'text', conf:'text', env:'text', log:'text', sql:'text',
  php:'text', java:'text', c:'text', cpp:'text', h:'text', hpp:'text',
  go:'text', rb:'text', rs:'text', toml:'text',
};

export function getExt(f) { return (f?.split('.').pop() || '').toLowerCase(); }

export function getPreviewType(f) { return PREVIEW_TYPES[getExt(f)] || null; }
